import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { solutionSettings, SolutionPlatform } from '../../data/solutions';
import { fadeUp } from '../../utils/motion';
const platformLabel: Record<SolutionPlatform, string> = {
  SKP: 'Semantic Knowledge Platform',
  'Human Capability': 'Human Capability Platform',
  Both: 'SKP + Human Capability Platform'
};
export function SolutionSettings() {
  const scrollTo = (id: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section className="bg-white py-20 lg:py-28" data-id="element-2071" data-mp="2vxe853u5eg63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-2072" data-mp="30zlmu16d4ac4">
        <nav aria-label="Solution settings" className="hidden lg:block lg:col-span-3" data-id="element-2073" data-mp="2n03sl6aas4vd">
          <div className="sticky top-28" data-id="element-2074" data-mp="2rwu9fvtxf4hu">
            <p className="text-sm font-medium text-ink-muted mb-4" data-id="element-2075" data-mp="2rzymzjta7cl6">Settings</p>
            <ul className="border-l border-line" data-id="element-2076" data-mp="1oojuvnxpz1oe">
              {solutionSettings.map(item => <li key={item.id} data-id="element-2077" data-mp="1ko9my5qda16w">
                  <a href={`#${item.id}`} onClick={scrollTo(item.id)} className="block -ml-px border-l-2 border-transparent hover:border-navy pl-4 py-1.5 text-sm text-ink-muted hover:text-navy transition-colors duration-150" data-id="element-2078" data-mp="1yoaqxu1xhoql">
                    {item.setting.replace('For ', '')}
                  </a>
                </li>)}
            </ul>
          </div>
        </nav>

        <div className="lg:col-span-9" data-id="element-2079" data-mp="1fqraw6h1z5uo">
          {solutionSettings.map(item => <motion.article key={item.id} id={item.id} {...fadeUp} className="scroll-mt-28 border-t border-line py-14 first:border-t-0 first:pt-0" data-id="element-2080" data-mp="1ax58r88imkd4">
              <p className="text-sm font-medium text-teal mb-3" data-id="element-2081" data-mp="i9so53lx0mmg">{platformLabel[item.platform]}</p>
              <h2 className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight mb-3" data-id="element-2082" data-mp="2ic1zaukl6v6z">
                {item.setting}
              </h2>
              <p className="text-xl text-ink-dark mb-8" data-id="element-2083" data-mp="2s1vahugth8ap">{item.tagline}</p>

              <div className="grid grid-cols-1 xl:grid-cols-12 gap-8 xl:gap-12" data-id="element-2084" data-mp="2w3gqhoone2p4">
                <div className="xl:col-span-8 space-y-5" data-id="element-2085" data-mp="2w5jfc5e2dps9">
                  {item.paragraphs.map(paragraph => <p key={paragraph} className="text-lg text-ink-muted leading-relaxed" data-id="element-2086" data-mp="24c986y55ecyh">
                      {paragraph}
                    </p>)}
                  {item.safeguard && <div className="flex gap-4 bg-surface-muted rounded-lg p-5" data-id="element-2087" data-mp="2ddqoohmgwgnp">
                      <ShieldCheck size={20} className="text-navy-light shrink-0 mt-1" aria-hidden="true" data-id="element-2088" data-mp="3jtb0zzlhvf67" />
                      <p className="text-ink-dark leading-relaxed" data-id="element-2089" data-mp="3os49fdlxcfzi">{item.safeguard}</p>
                    </div>}
                </div>

                <aside className="xl:col-span-4" data-id="element-2090" data-mp="2q57cjpkpzl8">
                  <h3 className="text-sm font-semibold text-ink-dark mb-3" data-id="element-2091" data-mp="3twpvnvo8utek">Possible applications</h3>
                  <ul className="border-t border-line mb-6" data-id="element-2092" data-mp="3p5zn69kiuafn">
                    {item.applications.map(application => <li key={application} className="border-b border-line py-2.5 text-ink-muted" data-id="element-2093" data-mp="3l44olctz6b5k">
                        {application}
                      </li>)}
                  </ul>
                  <a href={item.link} className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-2094" data-mp="3b55fjt5asdi1">
                    {item.linkLabel}
                    <ArrowRight size={16} data-id="element-2095" data-mp="14gk09pofb5va" />
                  </a>
                </aside>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}